import { useModal } from "@/features/modal/ModalStackManager";
import { FormButtonBox } from "@/features/standard/form/FormButtonBox";
import { FormMain } from "@/features/standard/form/FormMain";
import { FormWrapper } from "@/features/standard/form/FormWrapper";
import customAlert from "@/features/ui/alert/Alert";
import { validateFormValues } from "@/utils/validation";
import { Button, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";

const Create = Object.assign(FormMain, {
  Button: Button,
  Input: TextInput,
  Wrapper: FormWrapper,
  ButtonBox: FormButtonBox,
});

export const PressDailyRegisterCreateForm = () => {
  const { closeModal } = useModal();

  const form = useForm({
    initialValues: {
      make: undefined,
      name: undefined,
      type: undefined,
      makeId: undefined,
      manager: undefined,
      inspection: undefined,
    },
  });

  const onSubmit = async () => {
    try {
      customAlert("프레스 일상점검 생성에 실패하였습니다.", "생성 실패", "red");
    } catch (e) {
      customAlert("프레스 일상점검 생성에 실패하였습니다.", "생성 실패", "red");
    }
  };

  return (
    <Create.Wrapper>
      <Create.Input label="기계 제조사" {...form.getInputProps("make")} />
      <Create.Input label="기계 이름" {...form.getInputProps("name")} />
      <Create.Input label="기계 종류" {...form.getInputProps("type")} />
      <Create.Input label="제조 번호" withAsterisk {...form.getInputProps("makeId")} />
      <Create.Input label="담당자" {...form.getInputProps("manager")} />
      <Create.Input label="검사 주기" {...form.getInputProps("inspection")} />
      <Create.ButtonBox>
        <Create.Button color="gray" onClick={closeModal}>
          취소
        </Create.Button>
        <Create.Button
          onClick={onSubmit}
          disabled={validateFormValues({
            pageType: "pressDailyRegister",
            values: form.values,
          })}
        >
          프레스 일상점검 생성
        </Create.Button>
      </Create.ButtonBox>
    </Create.Wrapper>
  );
};
